module.exports = __webpack_public_path__ + "img/pc图.3ceadf11.png";